import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import "./Footer.css";
import logo from "../images/bestestbestieslogo.png"; // Adjust path based on your file structure

const Footer = ({ scrollToSection }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          {/* Update links to use scrollToSection for smooth scrolling */}
          <a onClick={() => scrollToSection("donate")} className="footer-link">
            Donate
          </a>
          <a onClick={() => scrollToSection("privacy")} className="footer-link">
            Privacy Policy
          </a>
          <a onClick={() => scrollToSection("terms")} className="footer-link">
            ToU
          </a>
          <a onClick={() => scrollToSection("faq")} className="footer-link">
            FAQ
          </a>
          {/* "Contact" link keeps the external link as is */}
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSe6s3xtoca6WypzDIF0BfXScRiUfNmJMmlHFJQcRmmtTvkumg/viewform?embedded=true"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Contact
          </a>
        </div>
        <p className="footer-text">
          © 2024 Bestest Besties Collection. All rights reserved.
        </p>

        {/* Email collection section */}
        <div className="email-collection">
          <p className="email-text">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdNaGtCG79gs20VtP6fjhUp_ZoZNI6GWiYx-CONcshu-yvyOg/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="email-link"
            >
              Sign up for our newsletter
            </a>
          </p>
        </div>
      </div>

      {/* Adding the logo to the far right */}
      <div className="footer-logo">
        <img
          src={logo}
          alt="Coders Aid Fund Logo"
          className="footer-logo-img"
        />
      </div>
    </footer>
  );
};

// PropTypes validation
Footer.propTypes = {
  scrollToSection: PropTypes.func.isRequired, // Validate that scrollToSection is a function
};

export default Footer;
